import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( theme ) => ({
  
  drawer: {
    width: 416,
    inset: "unset !important",
  },
  drawerContainer: {
    width: 440,
    marginTop: 64,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
    overflow: "hidden",
    height: "calc(100% - 64px)",
    zIndex: 1300,
    position: "fixed",
    top: 0,
    right: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    [`@media (max-width: 600px)`]: {
      width: "100vw",
      marginTop: 56,
      height: "calc(100% - 56px)",
    },
  },
  title: {
    paddingLeft: 24,
    paddingRight: 12,
    minHeight: 56,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: theme.props.border,
  },
}));

export default useStyle;